
export const bankDetails = {
    bank1: {
        name: "EUR Bank Account", // Used only for the tab label
        details: {
            "Beneficiary Name": "AZ Strategy LLC",
            "IBAN": "DE07202208000046063501",
            "SWIFT / BIC Code": "SXPYDEHH",
            "Currency": "EUR",
            "Bank Country": "Germany",
            "Bank Name": "Banking Circle S.A.",
            "Bank Address": "Maximilianstr 54, Muenchen, D-80538, DE",
            "IMPORTANT": "Only for EUR payments via SEPA.",

        },
    },
    
    bank2: {
        name: "USA Bank Account", // Used only for the tab label
        details: {
            "Beneficiary Name": "AZ Strategy LLC",
            "Account Number": "202250039942",
            "SWIFT / BIC Code": "CHFGUS44021",
            "ABA Routing Number": "091311229",
            "Currency": "USD",
            "Bank Country": "United States",
            "Bank Name": "Choice Financial Group",
            "Bank Address": "4501 23rd Avenue S Fargo, ND 58104 USA",
            "IMPORTANT": "Only for payments in USD.",

        },
    },

    // Add more bank objects as needed
};
